import React, { useEffect, useState } from 'react';
import { useDependencies } from '@servicetitan/react-ioc';
import { observer } from 'mobx-react';
import { PrimaryApplicant } from './primary-applicant';
import { ApplicantMaritalStatus } from './applicant-marital-status';
import { CitizenshipInformation } from './citizenship-information';
import { ResidenceInformation } from './residence-information';
import { WorkingAddress } from './working-address';
import { CoApplicant } from './co-applicant';
import { ServiceFinanceStore } from '../../../../stores/service-finance.store';
import * as Styles from './application-information-page.less';

export const ApplicationInformationPage: React.FC = observer(() => {
    const [store] = useDependencies(ServiceFinanceStore);
    useEffect(() => {
        store.getSelectedProducts();
    }, [store]);
    const loan = store.applicationForm!.$.Loan;
    const desiredLoanAmount = loan.$.SalesAmount.value
        ? (parseFloat(loan.$.SalesAmount.value) - parseFloat(loan.$.DownPayment.value || '0')).toFixed(2)
        : 0;
    return (
        <div className={Styles.container}>
            <div className={Styles.title}>Loan Information</div>
            <div className={Styles.subTitle}>Desired Loan Amount</div>
            <div className={Styles.title}>${desiredLoanAmount}</div>
            <div className={Styles.title}>Applicant Information</div>
            <PrimaryApplicant
                applicant={store.applicationForm!.$.PrimaryApplicant}
                states={store.getStates()}
                validate={store.validateField}
            />
            {store.isMaritalStatusRequired && (
                <ApplicantMaritalStatus
                    marriage={store.applicationForm!.$.Marriage}
                    validate={store.validateField}
                />
            )}
            <CitizenshipInformation
                personalInfo={store.applicationForm!.$.PrimaryApplicant.$.PersonalInfo}
            />
            <ResidenceInformation
                residence={store.applicationForm!.$.Residence}
                validate={store.validateField}
            />
            <WorkingAddress
                homeAddress={store.applicationForm!.$.PrimaryApplicant.$.HomeAddress}
                workingAddress={store.applicationForm!.$.WorkingAddress}
                workingAddressSameAsPrimaryAddress={
                    store.applicationForm!.$.WorkingAddressSameAsPrimaryAddress
                }
                states={store.getStates()}
                validate={store.validateField}
            />
            <CoApplicant
                coApplicant={store.applicationForm!.$.CoApplicant}
                primaryAddress={store.applicationForm!.$.PrimaryApplicant.$.HomeAddress}
                hasCoApplicant={store.applicationForm!.$.hasCoApplicant}
                states={store.getStates()}
                validate={store.validateField}
            />
        </div>
    );
});
